import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import ErrorPage from '../components/common/ErrorPage';
import ReviewGroup from '../components/review/ReviewGroup';
import TopBar from '../components/common/TopBar';
import errorResponses from '../errorResponses';
import useGlynt from '../components/hooks/useGlynt';
import useSetOrg from '../components/hooks/useSetOrg';
import { AppContext } from '../App';
import { getIdFromUrl } from '../utils/getIdFromUrl';
import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import { useSetTitle } from '../components/hooks/useSetTitle';
function ReviewGroupPage() {
  const { dpid, id, tid, eid } = useParams<{
    dpid: string;
    id: string;
    tid: string;
    eid: string;
  }>();

  if (!id) {
    throw new Error("Missing 'id' parameter");
  }

  const { extractionIndex, setExtractionIndex } = React.useContext(AppContext);

  const glynt = useGlynt(dpid);
  const {
    data: extractionBatch,
    isPending,
    isError,
  } = useQuery({
    queryKey: ['extractionBatch', id],
    queryFn: async () => (await glynt).extractionBatch.retrieve(id)
  });

  const extractionIds = React.useMemo(() => {
    // get index from list of urls
    let groupKeys = extractionBatch ? Object.keys(extractionBatch.extractions_by_training_set) : [];
    let currentGroupKey = groupKeys.find((gk) => getIdFromUrl(gk) === tid) || 'None';
    return (
      extractionBatch?.extractions_by_training_set[currentGroupKey].map((url) =>
        getIdFromUrl(url)
      ) || []
    );
  }, [extractionBatch, tid]);

  useSetTitle(extractionBatch?.label ? `Review - ${extractionBatch?.label}` : '...');

  const { loading, error } = useSetOrg(dpid);

  if (isPending || loading) return <LinearProgress />;

  if (error) {
    return <ErrorPage error={errorResponses.invalidDataPool} />;
  } else if (isError) {
    return <ErrorPage error={errorResponses.failedToLoadExtractionBatch} />;
  }

  setExtractionIndex(extractionIds.indexOf(eid));

  return (
    <>
      <TopBar />
      {extractionBatch ? (
        <ReviewGroup
          ebId={extractionBatch.id}
          // groupId={groupId}
          extractionBatch={extractionBatch}
          extractionIndex={extractionIndex}
          extractionIds={extractionIds}
        />
      ) : null}
    </>
  );
}
export default ReviewGroupPage;
